import React from "react";
import { Box, Paper, IconButton, Typography, Tooltip, Divider } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const FormPage = ({ title, subtitle, backTo, onSubmit, actions, children }) => {
  const navigate = useNavigate();
  const goBack = () => (backTo ? navigate(backTo) : navigate(-1));

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", bgcolor: "background.default" }}>
      {/* Header */}
      <Box sx={{ px: 3, pt: 3, pb: 1, display: "flex", alignItems: "center", gap: 1.5 }}>
        <Tooltip title="Back">
          <IconButton
            onClick={goBack}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Box>
          <Typography variant="h5" fontWeight={600}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Content */}
      <Paper
        elevation={0}
        sx={{
          mx: 3,
          mb: 3,
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
        }}
      >
        <Box component="form" onSubmit={onSubmit}>
          <Box sx={{ p: { xs: 2.5, sm: 3, md: 4 }, maxWidth: 640, mx: "auto" }}>
            {children}
          </Box>

          {actions && (
            <>
              <Divider />
              <Box
                sx={{
                  px: { xs: 2.5, sm: 3, md: 4 },
                  py: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1.5,
                  bgcolor: "action.hover",
                }}
              >
                {actions}
              </Box>
            </>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default FormPage;
